<script>
  import { Modal } from 'bootstrap';
  let isAlertModalOpen = false;
  let modalTitle = '';
  let modalMessage = '';
  let extraMessage = '';
  let isSuccess = true;
  let isDeleteModel = false;
  let isConfirm = false;
  let isWarning = false;
  let extraCheckbox = false;
  let isTopHeading = 'Y';
  let yesText = 'Ok';
  let okFunc;
  let cancelFunc;
  let extraCheckboxChecked = false;
  let isHtmlMessage = false;
  let optionHeading = '';
  let options = [];
  let selectedOptions;
  export const show = (params) => {
    isSuccess = true;
    isConfirm = false;
    isWarning = false;
    extraCheckboxChecked = false;
    optionHeading = params.optionHeading != undefined ? params.optionHeading : '';
    options = params.options != undefined ? params.options : [];
    for (var i in options) {
      if (options[i].checked) {
        selectedOptions = options[i];
      }
    }
    isDeleteModel = params.isDeleteModel != undefined ? params.isDeleteModel : false;
    extraCheckbox = params.extraCheckbox != undefined ? params.extraCheckbox : false;
    isHtmlMessage = params.isHtmlMessage != undefined ? params.isHtmlMessage : false;
    isTopHeading = params.isTopHeading != undefined ? params.isTopHeading : 'Y';
    yesText = params.yesText != undefined ? params.yesText : 'Ok';
    modalTitle = params.title != undefined ? params.title : '';
    modalMessage = params.message != undefined ? params.message : 'Alert Me';
    extraMessage = params.extraMessage != undefined ? params.extraMessage : '';
    let type = params.type != undefined ? params.type : 'warning';
    okFunc = params.okFunc != undefined ? params.okFunc : () => {};
    cancelFunc = params.cancelFunc != undefined ? params.cancelFunc : () => {};
    if (type != undefined && type == 'confirm') {
      isConfirm = true;
    } else if (type != undefined && type == 'error') {
      isSuccess = false;
    } else if (type != undefined && type == 'warning') {
      isWarning = true;
      isSuccess = false;
    } else {
      isSuccess = true;
    }

    //isAlertModalOpen = true;
    let commonModal = new Modal(document.getElementById('common_modal'), {
      keyboard: false,
      backdrop: 'static',
    });
    commonModal.show();
  };
  function hide(comeFrom) {
    if (comeFrom != undefined) {
      comeFrom == 'ok' && okFunc && okFunc({ extraCheckboxChecked, selectedOptions });
      comeFrom == 'cancel' && cancelFunc && cancelFunc();
    }
    //isAlertModalOpen = false;
    var commonModal = Modal.getInstance(document.getElementById('common_modal'));
    commonModal.toggle();
  }
</script>

<div
  class="modal"
  id="common_modal"
  data-bs-backdrop="static"
  tabindex="-1"
  aria-labelledby="Common Modal Label"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div class="d-flex align-items-end justify-content-end">
          <button
            type="button"
            on:click={() => hide('cancel')}
            class="btn-close"
            aria-label="Close"
          ></button>
        </div>
        {#if modalMessage != '' && modalMessage != undefined}
          <p class="font-size-16 pl-2 pr-2 p-line mb-3 text-center d-flex flex-column white-space">
            {#if isDeleteModel}
              <img
                class="mb-3"
                alt=""
                src="/images/cancel-icon.svg"
                style=" max-height: 40px;max-width: 40px;margin: auto; "
              />
            {:else if isConfirm}
              <img
                class="mb-3"
                alt=""
                src="/images/warning-icon.svg"
                style=" max-height: 40px;max-width: 40px;margin: auto; "
              />
            {:else if isSuccess}
              <img
                class="mb-3"
                alt=""
                src="/images/tick-success.png"
                style=" max-height: 40px;max-width: 40px;margin: auto; "
              />
            {:else}
              <img
                class="mb-3"
                alt=""
                src="/images/warning-icon.svg"
                style=" max-height: 40px;max-width: 40px;margin: auto; "
              />
            {/if}

            {#if typeof modalMessage == 'object'}
              {#each modalMessage as item}
                <span class="mt-2 d-block">{item}</span>
              {/each}
            {:else}
              <span class="font-size-18 font-weight-500 color-denim">
                <!-- <img  alt="" class="modal-img-small mr-2" src="/images/headerLogo.png" /> -->
                {#if isTopHeading == 'Y'}
                  {#if isConfirm}
                    Confirm
                  {:else if isSuccess}
                    Success
                  {:else if isSuccess}Success{:else}Error{/if}
                {/if}
                {modalTitle}
              </span>

              {#if extraCheckbox}
                <div class="checkbox c-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      name="requireReview"
                      checked={extraCheckboxChecked}
                      on:change={(event) => (extraCheckboxChecked = event.target.checked)}
                    />
                    <span class="check-img" />{modalMessage}
                  </label>
                </div>
              {:else if isHtmlMessage}
                {@html modalMessage}
              {:else}
                {modalMessage}
              {/if}
            {/if}
          </p>
          <!-- Move option heading out of options, to act as subHeading -->
          {#if optionHeading != ''}
            <p class="font-size-14 pl-2 pr-2 p-line mb-3 d-flex flex-column">
              {optionHeading}
            </p>
          {/if}
          {#if options.length > 0}
            <p class="font-size-14 ps-2 pr-2 p-line mb-3 d-flex flex-column">
              {#each options as option}
                <div class="radio c-radio mb-2">
                  <label class="d-block">
                    <input
                      type="radio"
                      name="options"
                      value={option.value}
                      checked={option.checked}
                      on:change={(event) => {
                        options = options.map((item) => {
                          return {
                            ...item,
                            checked: option.value == item.value,
                          };
                        });
                        selectedOptions = option;
                      }}
                    />
                    <span class="check-img" />{option.label}
                  </label>
                </div>
              {/each}
            </p>
          {/if}
          {#if extraMessage != '' && extraMessage != undefined}
            <p class="font-size-16 pl-2 pr-2 p-line mb-3 text-center d-flex flex-column">
              {extraMessage}
            </p>
          {/if}
        {/if}
      </div>
      <div class="modal-footer border-0 pt-0 align-items-center mb-4 justify-content-center">
        {#if isConfirm}
          <button
            class="btn trans-btn mb-0 outline-0 btn-cancel me-2 font-size-13 px-4 shadow-none"
            on:click={() => {
              hide('cancel');
            }}>Cancel</button
          >
        {/if}
        <button
          class="btn btn-primary mb-0 outline-0 me-2 font-size-13 px-4 btn-save shadow-none"
          on:click={() => {
            hide('ok');
          }}>{yesText}</button
        >
      </div>
    </div>
  </div>
</div>
